import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/jb-feature-list/jb-feature-list.css.ts
var jb_feature_list_css_default = i`ul{font-family:var(--theme-font-regular-family, VerlagSSm, Tahoma, sans-serif);font-weight:var(--theme-font-regular-weight, 400)}ul{font-size:var(--theme-typo-p-mini-highlight-desktop-fontsize, 0.813rem);line-height:var(--theme-typo-p-mini-highlight-desktop-lineheight, 1.25rem)}ul{list-style-type:none;padding-block-end:var(--spacing-2xs)}ul li{column-gap:var(--spacing-2xs);display:flex;margin:0;padding-block-start:var(--spacing-base)}`;

export {
  jb_feature_list_css_default
};
